const STORAGE_KEY = "pwa_app";

export function getStoredPwaApp() {
  if (typeof window === "undefined") return null;
  const value = window.localStorage.getItem(STORAGE_KEY);
  return value === "admin" || value === "attendance" ? value : null;
}

export function setStoredPwaApp(appId) {
  if (typeof window === "undefined") return;
  window.localStorage.setItem(STORAGE_KEY, appId);
  window.__PWA_APP = appId;
}

export function readPwaAppFromUrl(search = "") {
  const params = new URLSearchParams(search);
  if (params.get("app") === "admin") return "admin";
  if (params.get("mode") === "pwa" && !params.get("app")) return "attendance";
  return null;
}

export function isAdminPwaContext() {
  if (typeof window === "undefined") return false;
  if (window.__PWA_APP === "admin") return true;
  if (getStoredPwaApp() === "admin") return true;
  return readPwaAppFromUrl(window.location.search) === "admin";
}

export function syncPwaAppFromLocation() {
  if (typeof window === "undefined") return getStoredPwaApp() || "attendance";

  const fromUrl = readPwaAppFromUrl(window.location.search);
  if (fromUrl) {
    setStoredPwaApp(fromUrl);
    return fromUrl;
  }

  if (window.__IS_PWA && getStoredPwaApp()) {
    window.__PWA_APP = getStoredPwaApp();
    return getStoredPwaApp();
  }

  if (window.location.pathname.startsWith("/super-admin")) {
    window.__PWA_APP = "admin";
    return "admin";
  }

  window.__PWA_APP = getStoredPwaApp() || "attendance";
  return window.__PWA_APP;
}
